import * as Header from '../../constants/Header';

// TODO:constantsにうつす
// 0: なし
const NONE: number = 0;
// 1: メニューに戻る
// const BACK_MENU: number = 1;
// 2: 利用者一覧に戻る
// const BACK_USER_LIST: number = 2;
// 3: 管理画面に戻る
const SETTING: number = 3;

const initialState = {
  // ログインはデフォルトなので
  title: '運動促進',
  // 左上のバック
  back_type: NONE,
  // 右上の検索枠の有無
  is_search: false,
  // 右上の利用者設定の新規登録ボタンの有無
  is_register_btn: false,
  // 右上の利用者設定ボタンの有無
  is_user_setting_btn: false,
  // 右上のログアウトの有無
  is_logout: false,
  // 特殊なのはヘッダなし.
  no_header: false,
};

// プロパティ名になる.
const header = (state: any = initialState, action: any) => {
  // alert(action.type);
  switch (action.type) {
    case Header.LOGIN:
      return Object.assign({}, state, {
        title: 'ログイン画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.ADMIN_MENU:
      return Object.assign({}, state, {
        title: 'メニュー画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: true,
        is_logout: true,
      });
    case Header.MENU:
      return Object.assign({}, state, {
        title: 'レポートメニュー',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: true,
        is_logout: true,
      });
    case Header.PATIENT_LIST:
      return Object.assign({}, state, {
        title: '顧客一覧画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.DOCTOR_LIST:
      return Object.assign({}, state, {
        title: '医師一覧画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.HOSPITAL_LIST:
      return Object.assign({}, state, {
        title: '医療機関一覧画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.INQUIRY_LIST:
      return Object.assign({}, state, {
        title: '問い合わせ一覧画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.DOCTOR_DETAIL:
      return Object.assign({}, state, {
        title: '医師詳細画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.PATIENT_DETAIL:
      return Object.assign({}, state, {
        title: '顧客詳細画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.HOSPITAL_DETAIL:
      return Object.assign({}, state, {
        title: '医療機関詳細画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.INQUIRY_DETAIL:
      return Object.assign({}, state, {
        title: '問い合わせ詳細画面',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.SETTING:
    case Header.SETTING_FORGOT_PASSWORD_CODE:
      return Object.assign({}, state, {
        title: '管理',
        back_type: NONE,
        is_search: false,
        is_logout: true,
      });
    case Header.SETTING_CHANGE_PASSWORD:
    case Header.SETTING_FORGOT_PASSWORD:
      return Object.assign({}, state, {
        title: '管理',
        back_url: '/settings.html',
        back_type: SETTING,
        is_search: false,
        is_logout: true,
      });
    default:
      return state;
  }
};

export default header;



// WEBPACK FOOTER //
// ./src/store/reducers/Header.tsx